<template>
  <v-layout fill-height row>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <div
        class="card card-stats card-height"
        style="background-color: #f4f3ef; border-radius: 10px"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-3 col-md-2">
              <div class="icon-big text-center icon-warning">
                <v-icon class="icon_card_invporarea" color="#2c3e50" large
                  >home_work</v-icon
                >
              </div>
            </div>
            <div class="col-9 col-md-10" style="align-self: center">
              <div class="numbers" style="text-align: center">
                <p class="card-category text-primary" style="font-weight: bold">
                  INFRAESTRUCTURA CTI
                </p>
                <p></p>
              </div>
            </div>
          </div>
          <div id="chart">
            <apexchart
              type="donut"
              height="500"
              :options="chartOptionsInfraestructura"
              :series="chartOptionsInfraestructura.series"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <div
        class="card card-stats card-height"
        style="background-color: #f4f3ef; border-radius: 10px"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-3 col-md-2">
              <div class="icon-big text-center icon-warning">
                <v-icon class="icon_card_invporarea" color="#2c3e50" large
                  >workspaces</v-icon
                >
              </div>
            </div>
            <div class="col-9 col-md-10" style="align-self: center">
              <div class="numbers" style="text-align: center">
                <p class="card-category text-primary" style="font-weight: bold">
                  GRUPOS DE INVESTIGACIÓN
                </p>
                <p></p>
              </div>
            </div>
          </div>
          <div id="chart">
            <apexchart
              type="bar"
              height="440"
              :options="chartOptionsGrupos"
              :series="seriesGrupos"
            ></apexchart>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12">
      <div
        class="card card-stats card-height"
        style="background-color: #f4f3ef; border-radius: 10px"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-3 col-md-2">
              <div class="icon-big text-center icon-warning">
                <v-icon class="icon_card_invporarea" color="#2c3e50" large
                  >build</v-icon
                >
              </div>
            </div>
            <div class="col-9 col-md-10" style="align-self: center">
              <div class="numbers" style="text-align: center">
                <p class="card-category text-primary" style="font-weight: bold">
                  OFERTA DE SERVICIOS CTI
                </p>
                <p></p>
              </div>
            </div>
          </div>
          <div id="chart">
            <apexchart
              type="donut"
              height="500"
              :options="chartOptionsServicios"
              :series="chartOptionsServicios.series"
            ></apexchart>
          </div>
        </div>
      </div>
      <br />
      <br />
    </div>
  </v-layout>
</template>

<script>
import axios from "axios";
export default {
  props: ["urlApi","configuracion"],
  data() {
    return {
      infraestructura: {},
      grupos_de_investigacion: {},
      servicios: {},

      chartOptionsGrupos: {
        chart: {
          type: "bar",
          height: 380,
        },
        plotOptions: {
          bar: {
            barHeight: "100%",
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: "bottom",
            },
          },
        },
        colors: [
          "#1976D2",
          "#2196F3",
          "#03A9F4",
          "#00BCD4",
          "#26C6DA",
          "#4DD0E1",
          "#B2FF59",
          "#69FFA7",
          "#5FE8C9",
        ],

        dataLabels: {
          enabled: false,
          textAnchor: "start",
          style: {
            colors: ["#fff"],
          },
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ": " + val;
          },
          offsetX: 0,
          dropShadow: {
            enabled: true,
          },
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        xaxis: {
          categories: [
            "I.- FISICO-MATEMATICAS Y CIENCIAS DE LA TIERRA",
            "II.- BIOLOGÍA Y QUÍMICA",
            "III.- MEDICINA Y CIENCIAS DE LA SALUD",
            "IV.- CIENCIAS DE LA CONDUCTA Y EDUCACIÓN",
            "V.- HUMANIDADES",
            "VI.- CIENCIAS SOCIALES",
            "VII.- CIENCIAS DE AGRICULTURA, AGROPECUARIAS, FORESTALES Y DE ECOSISTEMAS",
            "VIII.- INGENIERÍAS Y DESARROLLO TECNOLÓGICO",
            "IX.- INTERDISCIPLINARIA",
          ],
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        tooltip: {
          theme: "dark",
          x: {
            show: false,
          },
          y: {
            title: {
              formatter: function (val, opt) {
                return (
                  '<div class="legend-info">' +
                  "<span>" +
                  "<span>" +
                  opt.w.globals.labels[opt.dataPointIndex] +
                  ": " +
                  "</span>" +
                  "</div>"
                );
              },
            },
          },
        },
      },
    };
  },
  computed: {
    chartOptionsServicios: function () {
      return {
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
        colors: [
          "#1976D2",
          "#2196F3",
          "#03A9F4",
          "#00BCD4",
          "#26C6DA",
          "#4DD0E1",
          "#B2FF59",
          "#69FFA7",
          "#5FE8C9",
          "#9b9b9b",
        ],
        legend: {
          fontSize: "14px",
          position: "bottom",
          fontFamily: "Helvetica, Arial",
          fontWeight: 400,
          itemMargin: {
            vertical: 10,
          },
          formatter: function (seriesName, opts) {
            return (
              '<div class="legend-info">' +
              "<span>" +
              seriesName +
              ": " +
              "</span>" +
              "<span>" +
              opts.w.globals.series[opts.seriesIndex] +
              "</span>" +
              "</div>"
            );
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            let percentaje = val.toFixed(2) + "%";
            return percentaje;
          },
        },
        labels: [
          "Asesoria",
          "Capacitación",
          "Servicios de laboratorio",
          "Incubadora",
          "Transferencia tecnológica",
          "Consultoría",
          "Prácticas profesionales",
          "Arrendamiento de espacio e infraestructura",
          "Desarrollo de nuevos productos",
          "Otros",
        ],

        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: "22px",
                  fontFamily: "Roboto",
                  color: "#dfsda",
                  offsetY: -10,
                },
                value: {
                  show: true,
                  fontSize: "16px",
                  fontFamily: "Roboto",
                  color: undefined,
                  offsetY: 16,
                  formatter: function (val) {
                    return val;
                  },
                },
                total: {
                  show: true,
                  label: "Total",
                  color: "#373d3f",
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce((a, b) => {
                      return a + b;
                    }, 0);
                  },
                },
              },
            },
          },
        },
        series: [
          this.servicios.asesoria,
          this.servicios.capacitacion,
          this.servicios.servicios_de_laboratorio,
          this.servicios.incubadora,
          this.servicios.transferencia_tecnologica,
          this.servicios.consultoria,
          this.servicios.practicas_profesionales,
          this.servicios.arrendamiento_de_espacio,
          this.servicios.desarrollo_de_nuevos_productos,
          this.servicios.otros,
        ],
      };
    },
    chartOptionsInfraestructura: function () {
      return {
        colors: ["#1976D2", "#00BCD4", "#2196F3", "#B2FF59"],
        legend: {
          fontSize: "14px",
          position: "bottom",
          fontFamily: "Helvetica, Arial",
          fontWeight: 400,
          itemMargin: {
            vertical: 10,
          },
          formatter: function (seriesName, opts) {
            return (
              '<div class="legend-info">' +
              "<span>" +
              seriesName +
              ": " +
              "</span>" +
              "<span>" +
              opts.w.globals.series[opts.seriesIndex] +
              "</span>" +
              "</div>"
            );
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            let percentaje = val.toFixed(2) + "%";
            return percentaje;
          },
        },
        labels: [
          "Laboratorios de Investigación",
          "Plantas Piloto",
          "Laboratorio de Pruebas",
          "Campos Experimentales",
        ],

        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: "22px",
                  fontFamily: "Roboto",
                  color: "#dfsda",
                  offsetY: -10,
                },
                value: {
                  show: true,
                  fontSize: "16px",
                  fontFamily: "Roboto",
                  color: undefined,
                  offsetY: 16,
                  formatter: function (val) {
                    return val;
                  },
                },
                total: {
                  show: true,
                  label: "Total",
                  color: "#373d3f",
                  formatter: function (w) {
                    return w.globals.seriesTotals.reduce((a, b) => {
                      return a + b;
                    }, 0);
                  },
                },
              },
            },
          },
        },
        series: [
          this.infraestructura.laboratorios_de_investigacion,
          this.infraestructura.plantas_piloto,
          this.infraestructura.laboratorio_de_pruebas,
          this.infraestructura.campos_experimentales,
        ],
      };
    },
    seriesGrupos: function () {
      return [
        {
          data: [
            this.grupos_de_investigacion
              .fisico_matematicas_y_ciencias_de_la_tierra,
            this.grupos_de_investigacion.biologia_y_quimica,
            this.grupos_de_investigacion.medicina_y_ciencias_de_la_salud,
            this.grupos_de_investigacion.ciencias_de_la_conducta_y_educacion,
            this.grupos_de_investigacion.humanidades,
            this.grupos_de_investigacion.ciencias_sociales,
            this.grupos_de_investigacion
              .ciencias_de_agricultura_agropecuarias_forestales_y_de_ecosistemas,
            this.grupos_de_investigacion.ingenierias_y_desarrollo_tecnologico,
            this.grupos_de_investigacion.interdisciplinaria,
          ],
        },
      ];
    },
  },
  mounted() {
    var urlGrupos= process.env.VUE_APP_API_URL + "/api/indicador-grupos-de-investigacion";
    axios
      .get(urlGrupos)
      .then((response) => {
        this.grupos_de_investigacion = response.data;
      });
      var urlInfrestructura = process.env.VUE_APP_API_URL + "/api/indicador-infrestructura";
    axios
      .get(urlInfrestructura)
      .then((response) => {
        this.infraestructura = response.data;
      });
      var urlServicios = process.env.VUE_APP_API_URL + "/api/indicador-servicios";
    axios
      .get(urlServicios)
      .then((response) => {
        this.servicios = response.data;
      });
  },
};
</script>

<style scoped>
.icon_card_invporarea {
  /* box-shadow: inset 3px 3px 5px 0 rgba(0, 0, 0, 0.2), inset -3px -3px 5px 0 rgba(255, 255, 255, 0.5), 6px 6px 10px 0 rgba(0, 0, 0, 0.2), -6px -6px 10px 0 rgba(255, 255, 255, 0.5); */
  align-items: center;
  border-radius: 100px;
  display: flex;
  height: 5px;
  justify-content: center;
  width: 5px;
  border: solid 30px;
  /* background-color: gainsboro; */
  border-color: gainsboro;
}
</style>